/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_Delete_ConfirmInputs */

const cs_social_templates_delete_confirm = /** @type {(inputs: Social_Templates_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tuto šablonu?`)
};

const en_social_templates_delete_confirm = /** @type {(inputs: Social_Templates_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this template?`)
};

/**
* | output |
* | --- |
* | "Delete this template?" |
*
* @param {Social_Templates_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_delete_confirm = /** @type {((inputs?: Social_Templates_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_delete_confirm(inputs)
	return cs_social_templates_delete_confirm(inputs)
});